module.exports = __webpack_public_path__ + "images/history-bg-afcad41493e2190a0cc8ef7c7f9c10f5.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./web/images/history-bg.svg
 ** module id = 385
 ** module chunks = 0
 **/